import {useQuery} from 'react-query';
import config from '../../config';

const fetchRecoBrands = async (options) => {
  const {brand, colorId, limit = 4, sortBy, styleId} = options || {};
  const queryParams = new URLSearchParams();
  if (brand) {
    queryParams.append('brand', brand);
  }
  if (colorId) {
    queryParams.append('colorId', colorId);
  }
  if (limit) {
    queryParams.append('limit', limit);
  }
  if (styleId) {
    queryParams.append('styleId', styleId);
  }
  if (sortBy) {
    queryParams.append('sortBy', sortBy);
  }
  const response = await fetch(
    `${config.services.recommendations.apiUrl}/api/v1/related-products/brand${queryParams ? `?${queryParams}` : ''}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch recommended styles', {
      response,
      styleId
    });
  }
  return response.json();
};

const useRecoBrands = (options = {}) => {
  const {
    brand,
    colorId,
    limit = 4,
    sortBy,
    styleId
  } = options?.queryParams || {};
  return useQuery({
    queryFn: () => fetchRecoBrands({brand, colorId, limit, sortBy, styleId}),
    queryKey: ['recoBrands', styleId, colorId, limit, brand, sortBy],
    ...options
  });
};

export default useRecoBrands;
